import { render, staticRenderFns } from "./AdjustmentsView.vue?vue&type=template&id=68a6aebb&"
import script from "./AdjustmentsView.vue?vue&type=script&lang=js&"
export * from "./AdjustmentsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports